import { Capacitor, registerPlugin } from '@capacitor/core';

interface PaymentNavigationPlugin {
    setActive(options: { active: boolean }): Promise<{ active: boolean }>;
    isActive(): Promise<{ active: boolean }>;
}

const plugin = registerPlugin<PaymentNavigationPlugin>('PaymentNavigation');

/**
 * 결제 중에만 http(s) 이동을 앱 웹뷰 안에 붙잡아 둔다.
 * 웹 브라우저에서는 아무것도 하지 않는다(플러그인 미구현 예외를 삼킨다).
 */
export async function setPaymentMode(active: boolean): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;
    try {
        await plugin.setActive({ active });
    } catch (error) {
        // 플러그인 미등록(구버전 앱) — 기존 동작으로 폴백된다
        console.warn('PaymentNavigation.setActive 실패:', error);
    }
}
